import { render, staticRenderFns } from "./DataManagePage.vue?vue&type=template&id=778d2da0&"
import script from "./DataManagePage.vue?vue&type=script&lang=js&"
export * from "./DataManagePage.vue?vue&type=script&lang=js&"
import style0 from "./DataManagePage.vue?vue&type=style&index=0&id=778d2da0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports